import { render } from "./student-courses.vue?vue&type=template&id=36a46932"
import script from "./student-courses.vue?vue&type=script&lang=js"
export * from "./student-courses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__